// extracted by mini-css-extract-plugin
module.exports = {"content":"Layout_content__nbzEe","padded":"Layout_padded__T9xBZ","topBorder":"Layout_topBorder__wHIbC","standalone":"Layout_standalone__puMR4","app":"Layout_app__JFlw8"};